import { makeRequest } from 'utils/requestLogger';

export default (commentID) =>
  makeRequest('put', `/api/comments/${commentID}/toggle-star`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/comment/toggleStar.js